/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import { LabelAtom } from "../../../atoms/LabelAtom";
import { Check, Label, LabelName } from "./SidebarStyles";
import { standardLabels } from "../../../styles/labels";
import {
  ClearFilterAtom,
  FilterCounterAtom,
  SelectedLabelAtom,
} from "../../../atoms/ContactFilterAtoms";
import { ContactFiltersAtom } from "../../../atoms/ContactFiltersAtom";
import IconBerserkerMail from "../../Icon";
import { notSelect } from "../../../styles/general";
import { useEffect, useMemo } from "react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ItemDiv = styled.div`
  display: flex;
  align-items: center;
  margin: 5px 0px;
  cursor: pointer;
  ${notSelect}
`;

export default function FilterByLabel() {
  const labels = useRecoilValue(LabelAtom);
  const setFilterCounter = useSetRecoilState(FilterCounterAtom);
  const [selectedLabel, setSelectedLabel] = useRecoilState(SelectedLabelAtom);
  const [contactFilters, setContactFilters] =
    useRecoilState(ContactFiltersAtom);

  const shouldClear = useRecoilValue(ClearFilterAtom);

  function onFilterLabelChange(label: string, noLabel: boolean) {
    let newLabels: string[] = [];

    if (selectedLabel.includes(label)) {
      newLabels = selectedLabel.filter((sl) => sl !== label);
      setFilterCounter((c) => ({
        ...c,
        byLabelCount: c.byLabelCount - 1,
      }));
    } else {
      setFilterCounter((c) => ({
        ...c,
        byLabelCount: c.byLabelCount + 1,
      }));
      newLabels = [...selectedLabel, label];
    }
    setSelectedLabel(newLabels);
    setContactFilters((oldFilter) => ({
      ...oldFilter,
      labels: newLabels,
    }));
  }

  useEffect(() => {
    if (shouldClear) {
      setSelectedLabel([]);
    }
  }, [shouldClear]);

  const memorizedLabels = useMemo(() => {
    return labels
      .slice()
      .sort((a, b) => a.labelIndex - b.labelIndex)
      .map((elem) => {
        const labelCss = standardLabels.find(
          ({ color }) => color === elem.color
        );

        return (
          <ItemDiv onClick={() => onFilterLabelChange(elem._id, false)}>
            <Label
              css={css`
                background-color: ${labelCss?.color || elem.color};
                border-color: ${labelCss?.borderColor || elem.color};
              `}
            >
              {selectedLabel.includes(elem._id) && (
                <Check src={"./icons/check.svg"} />
              )}
            </Label>
            <LabelName>{elem.name}</LabelName>
          </ItemDiv>
        );
      });
  }, [selectedLabel]);

  return (
    <Container>
      <ItemDiv
        onClick={() =>
          onFilterLabelChange(
            "noLabel",
            !contactFilters.labels?.includes("noLabel")
          )
        }
      >
        <Label
          css={css`
            background-color: #fff;
            border-color: #707070;
          `}
        >
          {selectedLabel.includes("noLabel") && (
            <IconBerserkerMail name="check" color="#707070" />
          )}
        </Label>
        <LabelName>No Label</LabelName>
      </ItemDiv>
      {labels && labels.length > 0 && memorizedLabels}
    </Container>
  );
}
